import React from 'react';

export default function LivePulse({ label = 'Live', size = 8, color = '#22c55e', marginTop = 3 }) {
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: marginTop }}>
      <span style={{ position: 'relative', display: 'inline-flex', width: size, height: size }}>
        {/* Ping ring */}
          <span style={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              background: color,
              opacity: 0.4,
              animation: 'livePing 1.4s ease-out infinite',
          }} />
          {/* Solid dot */}
          <span style={{
              position: 'relative',
              width: size,
              height: size,
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
          }} />
      </span>
            {label && (
                <span style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: color,
                    textTransform: 'uppercase',
                    letterSpacing: '.06em',
                }}>
          {label}
        </span>
            )}
            <style>{`
        @keyframes livePing {
          0%   { transform: scale(1);   opacity: 0.4; }
          70%  { transform: scale(2.4); opacity: 0;   }
          100% { transform: scale(2.4); opacity: 0;   }
        }
      `}</style>
    </span>
    );
}